<template>
  <div class="modalTable">
    <vxe-toolbar fixed="top">
      <template v-slot:buttons>
        <el-button type="primary" @click="clearRadioRowEevnt"
          >取消选中</el-button
        >
        <el-button type="primary" @click="getRadioEvent1">获取选中</el-button>
        <el-button type="primary" @click="funcFilter">查询</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable1"
      height="80%"
      border
      auto-resize
      class="radio-table"
      :radio-config="{ highlight: true }"
      :data="tableData"
      @radio-change="radioChangeEvent"
    >
      <vxe-table-column type="radio" width="60" />
      <vxe-table-column>
        <vxe-table-column
          field="consignorName"
          min-width="120"
          title="发货联系人"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.consignorName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consignorPhone"
          min-width="120"
          title="装货电话"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.consignorPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consigneeName"
          min-width="120"
          title="卸货联系人"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.consigneeName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consigneePhone"
          min-width="120"
          title="卸货电话"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.consigneePhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consignorAddress"
          min-width="200"
          title="发货地址"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.consignorAddress"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consigneeAddress"
          min-width="200"
          title="卸货地址"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.consigneeAddress"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import { commonRouteInfo } from "@/api/orderform";
export default {
  name: "Child",
  data() {
    return {
      loading: false,
      getdata: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      Pagingconf: [],
      tableData: []
    };
  },
  created() {},
  methods: {
    //查询长发路线
    shipmentlist() {
      commonRouteInfo(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
      });
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.shipmentlist();
    },
    //获取选中
    getRadioEvent1() {
      this.getdata = this.$refs.xTable1.getRadioRecord();
      if (this.getdata) {
        this.$emit("event6", this.getdata);
      } else {
        this.$message({ message: "请选择一个常跑路线", type: "warning" });
      }
    },
    //取消选中
    clearRadioRowEevnt() {
      this.selectRow = null;
      this.$refs.xTable1.clearRadioRow();
    },
    //选中事件
    radioChangeEvent({ row }) {
      this.selectRow = row;
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.shipmentlist();
    }
  }
};
</script>
